import { DynamicSegmentActionsTypes as Types } from 'actions/types';

const changeTabActiveIndex = (payload) => ({ type: Types.CHANGE_TAB_ACTIVE_INDEX, payload });

export default { changeTabActiveIndex };
